const en = {
    text: {
        search: 'Search',

        login_title: 'Login',
        loginaccount_title: 'Log In',
        login_btn_login: 'Log In with Email or Phone',
        login_tip: 'Read and agree',
        login_tip_privacy_policy: 'Privacy Policy',
        login_tip_and: 'and',
        login_tip_service_rules: 'Service Rules',
        login_not_have_account: 'Not have an account?',
        login_btn_register: 'Register',
        login_msg: 'Please agree and tick the Senda User Privacy Policy and Service Agreement.',
        registered_cna: 'Create New Account',
        registered_phn: 'Phone Number',
        registered_cfn: 'Confirm Number',
        registered_etc: 'Enter the code sent to',
        registered_snc: 'Send new code',
        registered_vfc: 'Verification code',
        registered_spa: 'Set Password',
        registered_cht: 'characters',
        registered_gtl: 'Go to log in',
        registered_ath: 'Go to Home',

        registered_wrtyt: 'Registration succeeded', // 注册成功
        registered_wokjt: 'automatically goes to the login page', // 自动进入登录页
        login_fail: 'Login failed', // 登陆失败
        login_fail_tip: 'The account or password is incorrect. Please enter it again', // 账号或密码错误，请重新输入
        verification_code_error: 'Verification code error', // 验证码错误
        successful_gtt: 'Password reset succeeded', // 重置密码成功
        perfect_qwer: 'Select the country code', // 选择国家区号
        perfect_tyui: 'Choose a country', // 选择国家
        perfect_qsde: 'Choose a Region', // 选择地区
        information_mne: 'Choosing Gender', // 选择性别
        perfect_oill: 'The information is complete', // 信息已完善
        perfect_nnmj: 'seconds to automatically enter the store for an appointment', // 自动进入门店预约
        perfect_ndyy: 'Skip store reservation', // 跳转门店预约
        able_iju: 'The current filter item does not match the result, try to changeit ~',// 当前筛选项无匹配结果，更换下试试吧~
        able_wer: 'No relevant data is available', // 暂无相关数据
        vori_sdw: 'Cancel collection successfully', // 取消收藏成功
        entif_oiu: 'In the process of identifying', // 正在识别
        scan_for_qr_code: 'Scan for QR Code', // 扫描二维码
        scan: 'Scan', // 扫描
        switch_camera: 'Switch Camera', // 切换摄像头
        up_suu: 'logout', // 登出
        up_swu: 'Confirm logout？', // 确认登出？
        up_slu: 'The account has been logged out', // 账号已登出
        seguridad_kja: 'Confirm the release？', // 确认解绑？
        seguridad_siu: 'After untying', // 解绑XX后
        seguridad_siu2: 'it will no longer be used to log in to the account', //将无法继续使用它登录该账号
        browse_xccfv: 'Filling in service evaluation', // 服务评价填写
        browse_erty: 'Do not fill in', // 不填写
        browse_bngh: 'To fill out', // 去填写
        did_wwe: 'Adding succeeded', // 添加成功
        calculate_mnrt: 'Please select a calculation record', // 请选择计算记录
        ping_joi: 'Confirm to delete the record？', // 确定删除该记录？
        ping_jki: 'Successfully deleted', // 删除成功
        ppn_oghs: 'Modified successfully', // 修改成功
        empty_ccr: 'Are you sure you want to clear the calculator? Deleted calculation items can be recovered from the most recent delete.', // 确认清空计算项吗？删除的计算项可在最近删除中恢复
        supprime_cgd: 'Are you sure to delete these calculations completely? This operation cannot be restored.', // 确认彻底清除这些计算项吗？清除后不可恢复。
        empty_ctl: 'confirm to clear this record?', // 确认删除该计算项吗？删除的计算项可在最近删除中恢复

        // 新增或缺失的翻译（去重并备注原始中文）
        tiles_sanitary: "Tiles & Sanitary",
        view: "View",
        real_case: "Real Case",
        see_all: "See All",
        appointment: "Appointment",
        distance: "km from you",
        unable_to_locate: "Unable to locate",
        brand: "Brand",
        collections: "Collections",
        login_successful: "Login Successfully",
        search: "Search",
        home: "Home",
        display: "Display",
        cases: "Cases",
        account: "Account",

        recommend_chrome: "It is recommended to use Chrome browser to access",
        not_chrome_use_chrome: "Currently non-Chrome browser, please use Chrome browser to access to get a better experience",

        products: "Products",
        popular: "Popular",
        popular_searches_hidden: "Current Popular searches are hidden",
        confirm_show_all_history: "Determine all historical records?",
        search_for_all: "Search for all",
        bathroom: "Bathroom",
        search_brand_info: "Search for brand info",
        search_space: "Search for space",
        non_slip_tile: "Non-slip Tile",
        please_enter_content: "Please enter content",
        no_relevant_results: "Unfortunately, there are no relevant results",
        try_searching: "Try Searching",
        more_products: "More Products",
        more_cases: "More Cases",

        search_for_store: "Search for Store",
        store_appointment: "Store Appointment",
        other_stores: "Other Stores",
        loading_complete: "Loading Complete",
        loading: "Loading...",
        search_store: "Search for Store",
        nearby_stores: "Nearby Stores",
        select_store: "Select Store",
        cancel: "Cancel",
        history: "History",
        artificial_service: "Artificial Service",
        online_service: "Online Service",
        
        product_not_exist: "The product does not exist", // 产品不存在
        product_offline: "The product has been taken offline", // 产品已下架

        amount: "Amount",
        appointment_info: "Appointment Information", // 原文: Appointment Information
        service_evaluation: "Service Evaluation",
        remarks: "Remarks",
        enter_additional_comments: "Enter additional comments",
        monday: "Monday",
        tuesday: "Tuesday",
        wednesday: "Wednesday",
        thursday: "Thursday",
        friday: "Friday",
        saturday: "Saturday",
        sunday: "Sunday",
        MON: "MON",
        TUE: "TUE",
        WED: "WED",
        THU: "THU",
        FRI: "FRI",
        SAT: "SAT",
        SUN: "SUN",
        to: "to",

        please_input: "Please Input",
        please_select: "Please Select",
        please_enter_your_needs: "Please enter your needs",
        appointment_time: "Appointment Time",
        date: "Date",
        required_fields_not_selected: "Required fields not selected.",
        time: "Time",
        information: "Information",
        name: "Name",
        first_name: "First name",
        last_name: "Last name",
        gender: "Gender",
        male: "Male",
        female: "Female",
        contact: "Contact",
        demand: "Demand",
        phone: "Phone",
        obtain: "Obtain",
        submit: "Submit",
        confirm: "Confirm",
        next: "Next",
        back: "Back",

        sort_by: "Sort By",
        filter: "Filter",
        reset: "Reset",
        default: "Default",
        newest: "Newest",
        trending: "Trending",
        apply: "Apply",
        basic_colors: "Basic Colors",
        marble_stone: "Marble & Stone",
        download_app_3d: "Download the app to view the 3D effect",
        showroom_products: "Showroom products",
        matching_records: "Matching Records",
        recognize_qr_code: "Recognize the QR Code",

        product_details: "Product Details",
        renderings: "Renderings",
        related_cases_products_in_model_room: "样板间使用产品", // 原文中文：样板间使用产品
        recommended_products: "Recommended Products",
        display_3d: "3D Display",
        collection: "Collection",
        basic_product_parameters: "Basic Product Parameters",
        functional_parameters: "Functional Parameters",
        close: "Close",
        share: "Share",
        info_to: "Info To",
        share_case_info_to: "Share Case Info To",
        copy_link: "Copy Link",
        space: "Space",
        download_app_tip: "Download the app to view the 3D effect",
        showroom_products: "Showroom products",

        log_in_with_account: "Log In with Account",
        you_are_logging_into_account_for: "You are logging into an account for",
        select_country_again: "If you are not in this country, please select again.",
        registering_into_account_for: "You are registering into an account for",
        already_have_account: "Already have an account?",
        phone_number_verification: "Phone Number Verification",
        accept_sms_verification_code: "By accepting SMS verification code",
        confirm_number: "Confirm Number",
        enter_code_sent_to: "Enter the code sent to",
        send_new_code: "Send new code",
        verification_code: "Verification Code",
        reset_password: "Reset Password",
        other_login_method: "Other Login Method",
        retrieve_password: "Retrieve Password",
        create_new_account: "Create New Account",
        retrieve_send_new_code: "Send new code",
        retrieve_reset_password: "Reset Password",
        required_fields_not_selected: "Required fields not selected.",
        login_password_placeholder: "6+ characters",
        // person page
        account: "Account",
        shopping_list: "Shopping List",
        wish_list: "Wish List",
        no_favorite_yet: "No Favorite Yet",
        read_more: "Read More",
        store_experience_records: "Store Experience Records",
        no_records_yet: "No records yet",
        no_case_yet: "No Case Yet",
        share_give_gift: "Share\nGive a Gift",
        give_friend_gift: "Give your friend a gift and get your gift too",
        go: "Go!",
        my_cases: "My Cases",
        no_cases: "No Cases",
        recently_viewed: "Recently Viewed",
        tips: "Tips",
        switching_countries_re_register: "Switching countries requires re-registering your account",
        not_logged_in: "Not Logged In",
        no_data_yet: "No data yet",
        sort: "Sort",
        browsing_type: "Browsing Type",
        content: "Content",
        last_view: "Last View",
        offline: "Offline",
        time_new_old: "Time (new-old)",
        time_old_new: "Time (old-new)",
        views_most_least: "Views (most-least)",
        views_least_most: "Views (least-most)",
        all: "All",
        online_browsing: "Online Browsing",
        offline_browsing: "Offline Browsing",
        product: "Product",
        case: "Case",
        display: "Display",
        set_up: "Set Up",
        log_out: "Log Out",
        personal_info: "Personal Info",
        account_security: "Account Security",
        first_name: "First Name",
        last_name: "Last Name",
        enter_your_first_name: "Enter your first name",
        enter_your_last_name: "Enter your last name",
        location: "Location",
        select_country_province_city: "Select Country / Province / City",
        gender: "Gender",
        select_your_gender: "Select your gender",
        male: "Male",
        female: "Female",
        language: "Language",
        select_language: "Select Language",
        english: "English",
        french: "Français",
        user_info_changed_save: "User information has changed, save it?",
        save_success: "Save Success",
        phone_info: "Phone Info",
        phone: "Phone",
        third_party_account_binding: "Third-party Account Binding",
        bind: "Bind",
        unbind: "Unbind",
        unbind_facebook_cannot_login: "After unbinding Facebook, you will not be able to continue using it to log in to this account",
        information_complete: "Complete Info",
        information_not_complete: "Information is not complete",
        login_password_requirement: "upper letter, small letter, number, at least 6 characters",
        your_phone_number: "Your Phone Number",
        password_requirement: "Password：6+ characte",
        other_login: "Other Login",
        facebook: "Facebook",
        google: "Google",

        shopping_list: "Shopping List",
        wish_list: "Wish List",
        read_more: "Read More",
        no_favorite_yet: "No Favorite Yet",
        store_experience_records: "Store Experience Records",
        share: "Share",
        give_a_gift: "Give a Gift",
        my_cases: "My Cases",
        go: "Go!",
        no_cases: "No Cases",
        recently_viewed: "Recently Viewed",

        country_selection: "Country Selection",
        based_on_your_location: "Based on your location,",
        auto_selected_country: "has been selected for you.",
        manual_select_country: "If the location is incorrect, please manually select your country.",
        switching_countries_requires_re_registering: "Switching countries requires re-registering your account, so please choose carefully.",

        select_all: "Select all",
        remove: "Remove",
        finish: "Finish",
        edit: "Edit",
        saved: "Saved",
        favourite: "Favorite",
        confirm_clear_all_favorites: "Confirmed to clear all favorites？",
        all: "All",

        my_appointment: "My Appointment",
        store_record: "Store Record",
        purchase_history: "Purchase History",
        ongoing: "Ongoing",
        completed: "Completed",
        considerate_service: "Considerate Service",
        attentive: "Attentive",
        patience: "Patience",
        communicate_smoothly: "Communicate Smoothly",
        high_professional: "High Professional",
        bad_attitude: "Bad Attitude",
        service_appointment_details: "Service Appointment Details",
        show_appointment_code: "Show Appointment Code",
        my_appointment_history: "My Appointment History",
        back_to_home: "Back To The Home",
        appointment_code_expired: "Appointment Code Expired",
        no_record: "No Record",
        browse_records: "Browse records",
        details: "Details",
        product_list: "Product List",
        no_browsing_history: "No Browsing History",
        purchase_history_detail: "Purchase History Detail",
        arrived: "Arrived",
        times: "Times",
        payment_voucher: "Payment Voucher",
        purchase_list: "Purchase List",
        brick_units_are_boxes: "Brick units are boxes",
        store_service_appointment: "Store Service Appointment",
        thanks_for_appointment: "Thanks for the appointment！We look forward to your visit！",
        contact_shopping_guide: "Contact Shopping Guide",
        appointment_code: "Appointment Code",
        show_to_shop_guider: "Show to the shop guider",
        go_to_shopping_list: "Go To Shopping List",
        service_appointment: "Service Appointment",

        location_failed: "Location Failed",
        positioning: "Positioning...",
        re_locate: "Re-locate",
        current_location: "Current Location",
        search_for_city: "Search for city",

        case_details: "Case Details",
        renderings: "Renderings",
        products_applied: "Products Applied",
        uploader: "Uploader",
        related_cases: "Related Cases",
        case: "Case",
        page_situation: "Page Situation",   //原文中文：页面情况
        situation1: "1、Search box temporarily cannot be clicked\n2、Case type interface network error\n3、Select city module waiting for location api\n4、Floating button cannot be clicked\n5、Case list data is missing part of the keyword\n6、Case list interface parameter sort is missing another data", // 原文中文：1、搜索框暂时不能点击\n2、案例分类接口报网络错误\n3、选择城市模块等待定位api\n4、悬浮按钮不能点击\n5、案例列表数据缺失部分关键字\n6、案例列表接口入参sort缺少另外的数据
        situation2: "1、Get details interface not working\n2、Top bar temporarily not debugged", // 原文中文：1、获取详情接口不通\n2、顶部栏暂时未调试
        situation3: "1、Recent shop location problem\n2、Interface returns video address cannot play\n3、Detail data is missing \n4、Customer service icon is missing\n", // 原文中文：1、最近商铺定位问题\n2、接口返回视频地址无法播放\n3、详情数据缺失 \n4、客服图标缺失\n

        calculator: "Calculator",
        meter: "meter (m)",
        feet: "feet (ft)",
        system_calc_method: "System Calculation Method:1 M²=10.7639104167 sqft",
        add_products: "Add Products",
        add_from: "Add From ",
        t_collections: "Collections",
        t_matching_records: "Matching Records",
        t_favorites: "Favorites",
        t_recently_viewed: "Recently Viewed",
        select_space: "Select Space",
        wall: "Wall",
        floor: "Floor",
        continuous_laying: "Continuous laying",
        area: "Area",
        door: "Door",
        window: "Window",
        pcs: "PCS",
        m2: "M²",
        sqft: "Sqft",
        change_products: "Change Products",
        subtotal: "Subtotal",
        box: "Box",
        no_record: "No Record",
        grand_total: "Grand Total",
        add_to_shopping_list: "Add To Shopping List",
        add_from_collections: "Add From Collections",
        add_from_favorites: "Add From Favorites",

        select_unit: "Select Unit",
        please_select_space_first: "Please select space first",
        copied: "Copied",
        deleted: "Deleted",
        clearing: "Clearing",
        saved_to_customer_view_pending_purchase_list: "Saved To The Customer You Can Click To View The Pending Purchase List",
        cannot_add_zero_box_products: "Products with zero boxes cannot be added to the to-buy list",

        id_number: "ID number",
        client: "Client",
        edited: "Edited",
        discount: "Discount",
        last_price: "Last Price",
        favorite_successfully: "Favorite successfully",
        success: "Success",
        unknown_current_region: "Do not know the current region.",
        login_before_scan: "请先登录后再扫码查看", // 原文中文
        invalid_qr_code: "无效的二维码", // 原文中文
        error_need_camera_permission: "ERROR: 您需要授予相机访问权限", // 原文中文
        error_no_camera_detected: "ERROR: 这个设备上没有摄像头", // 原文中文
        error_secure_context_required: "ERROR: 所需的安全上下文(HTTPS、本地主机)", // 原文中文
        error_camera_in_use: "ERROR: 相机被占用", // 原文中文
        error_camera_install_incorrect: "ERROR: 安装摄像头不合适", // 原文中文
        error_browser_not_support_stream_api: "ERROR: 此浏览器不支持流API", // 原文中文
        recognition_error: "识别错误", // 原文中文
        information_not_complete: "Information not complete",
        thank_you_feedback: "Thank you for your feedback",
        feedback_submission_failed: "Failed to submit feedback",
        applied: "Applied",
        fail: "Fail",
        choose_picture: "Choose a picture", // 原文中文
        error_get_details_failed: "获取详情失败", // 原文中文
        save_success: "保存成功", // 原文中文
        association_failed: "关联失败", // 原文中文
        zoom_in: "放大", // 原文中文
        zoom_out: "缩小", // 原文中文
        zoom: "缩放", // 原文中文
        
        // 新增缺失的翻译项
        thank_you_for_your_feedback: "Thank you for your feedback", // 原文: Thank you for your feedback
        feedback_submission_failed: "Failed to submit feedback", // 原文: Failed to submit feedback
        recently_deleted: "Recently Deleted", // 原文: Recently Deleted
        no_space_selected: "No space selected", // 原文: No space selected
        continuous_laying_quote: '"Continuous laying"', // 原文: "Continuous laying"
        length: "Length", // 原文: Length
        width: "Width", // 原文: Width
        in_total: "In Total", // 原文: In Total
        total: "Total", // 原文: Total
        no_data_yet: "No data yet", // 原文: No data yet
        restore: "Restore", // 原文: Restore
        clear: "Clear", // 原文: Clear
        search_product_name: "Search for product name", // 原文: Search for product name
        setup: "Set Up", // 原文: Set Up
        log_out: "Log Out", // 原文: Log Out
        personal_info: "Personal Info", // 原文: Personal Info
        account_security: "Account Security", // 原文: Account Security
        change_password: "Change Password", // 原文: Change Password
        enter_first_name: "Enter your first name", // 原文: Enter your first name
        enter_last_name: "Enter your last name", // 原文: Enter your last name
        location: "Location", // 原文: Location
        select_country_province_city: "'Select Country / Province / City'", // 原文: 'Select Country / Province / City'
        select_gender: "Select your gender", // 原文: Select your gender
        user_info_changed_save: "用户信息有变动，是否保存", // 原文中文
        switching_countries_requires_re_registering2: "Switching countries requires re-registering your account", // 原文: Switching countries requires re-registering your account
        sort: "Sort", // 原文: Sort
        browsing_type: "Browsing Type", // 原文: Browsing Type
        content: "Content", // 原文: Content
        offline: "Offline", // 原文: Offline
        time_new_old: "Time (new-old)", // 原文: Time (new-old)
        time_old_new: "Time (old-new)", // 原文: Time (old-new)
        views_most_least: "Views (most-least)", // 原文: Views (most-least)
        views_least_most: "Views (least-most)", // 原文: Views (least-most)
        online_browsing: "Online Browsing", // 原文: Online Browsing
        return: "返回", // 原文: 返回
        unlocked: "Unlocked", // 原文: Unlocked
        not_unlocked: "Not unlocked", // 原文: Not unlocked
        rating: "Rating", // 原文: Rating
        course_introduce: "Course Introduce", // 原文: Course Introduce
        tap_star_to_score: "Tap Star To Score", // 原文: Tap Star To Score
        what_think_of_course: "What do you think of the course?", // 原文: What do you think of the course?
        take_an_exam: "Take An Exam", // 原文: Take An Exam
        points: "Points", // 原文: Points
        today: "Today", // 原文: Today
        before: "Before", // 原文: Before
        min: "Min", // 原文: Min
        learn: "Learn", // 原文: Learn
        learned: "Learned", // 原文: 已学
        template: "<template>", // 原文: <template>
        list_of_the: "List of the", // 原文: List of the
        year: "Year", // 原文: Year
        month: "Month", // 原文: Month
        period_of_statistics: "Period of statistics", // 原文: Period of statistics
        annual: "Annual", // 原文: Annual
        monthly: "Monthly", // 原文: Monthly
        no_more: "没有更多了", // 原文中文
        by_date: "by date", // 原文: by date
        budget: "Budget", // 原文: Budget
        overall_points_ranking: "Overall points ranking", // 原文: Overall points ranking
        learning_points_ranking: "Learning points ranking", // 原文: Learning points ranking
        lecturers_points_ranking: "Lecturers points ranking", // 原文: Lecturers points ranking
        course_scoring_ranking: "Course scoring ranking", // 原文: Course scoring ranking
        january: "January", // 原文: January
        february: "February", // 原文: February
        march: "March", // 原文: March
        april: "April", // 原文: April
        may: "May", // 原文: May
        june: "June", // 原文: June
        july: "July", // 原文: July
        august: "August", // 原文: August
        september: "September", // 原文: September
        october: "October", // 原文: October
        november: "November", // 原文: November
        december: "December", // 原文: December
        category: "Category", // 原文: Category
        all_course: "All Course", // 原文: All Course
        determine_all_historical_records: "Determine all historical records", // 原文: Determine all historical records
        search_for_all: "Search for all", // 原文: Search for all
        lecturer: "Lecturer", // 原文: Lecturer
        application: "Application", // 原文: Application
        application_process: "1.Submit data - 2.Wait for review - 3.Contact someone if the review is successful", // 原文中文
    },
    // 商学院翻译
    business_school: {
        business_school: 'Business School',
        become_lecturer: 'Become A Lecturer',
        category: 'Category',
        all_course: 'All Course',
        my_learning: 'My Learning',
        ranking: 'Ranking',
        learning_history: 'Learning History',
        all: 'All',
        favorite: 'Favorite',
        
        // 新增商学院相关翻译项
        unfortunately_there_are_no: 'Unfortunately, there are no',
        relevant_results: 'Relevant Results',
        selected_all: "Selected all", // 原文: Selected all
        removed: "Removed", // 原文: Removed
        please_select_at_least_one_course_to_remove: "Please select at least one course to remove", // 原文: Please select at least one course to remove
        removed_successfully: "Removed successfully", // 原文: Removed successfully
        course: "Course", // 原文: Course
        take_exam: "Take An Exam", // 原文: Take An Exam
        course_intro: "Course Introduce", // 原文: Course Introduce
        tap_star_to_score: "Tap Star To Score", // 原文: Tap Star To Score
        what_do_you_think_of_course: "What do you think of the course?", // 原文: What do you think of the course?
        thank_you_for_feedback: "Thank you for your feedback", // 原文: Thank you for your feedback
        failed_to_submit_feedback: "Failed to submit feedback", // 原文: Failed to submit feedback
        points: "Points", // 原文: Points
        today: "Today", // 原文: Today
        before: "Before", // 原文: Before
        min: "Min", // 原文: Min
        learn: "Learn", // 原文: Learn
        learned: "Learned", // 原文: 已学
        list_of_the: "List of the", // 原文: List of the
        year: "Year", // 原文: Year
        month: "Month", // 原文: Month
        period_of_statistics: "Period of statistics", // 原文: Period of statistics
        annual: "Annual", // 原文: Annual
        monthly: "Monthly", // 原文: Monthly
        no_more: "没有更多了", // 原文中文
        by_date: "by date", // 原文: by date
        budget: "Budget", // 原文: Budget
        overall_points_ranking: "Overall points ranking", // 原文: Overall points ranking
        learning_points_ranking: "Learning points ranking", // 原文: Learning points ranking
        lecturers_points_ranking: "Lecturers points ranking", // 原文: Lecturers points ranking
        course_scoring_ranking: "Course scoring ranking", // 原文: Course scoring ranking
        january: "January", // 原文: January
        february: "February", // 原文: February
        march: "March", // 原文: March
        april: "April", // 原文: April
        may: "May", // 原文: May
        june: "June", // 原文: June
        july: "July", // 原文: July
        august: "August", // 原文: August
        september: "September", // 原文: September
        october: "October", // 原文: October
        november: "November", // 原文: November
        december: "December", // 原文: December
        lecturer: "Lecturer", // 原文: Lecturer
        application: "Application", // 原文: Application
        application_process: "1.Submit data - 2.Wait for review - 3.Contact someone if the review is successful", // 原文中文
        applied: "Applied", // 原文: Applied
        fail: "Fail", // 原文: Fail
    }
}

export default en;


// WEBPACK FOOTER //
// ./src/VueI18n/en.js